/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for Left Sidebar
Author: Deimos Space UK

Version: 1.0
*/

import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/ESA_logo_2020_White.png";
import logCollapsed from "../../../assets/images/ESA_logo_2020_White_Collapsed.png";
import {
  ProSidebar,
  SidebarHeader,
  SidebarContent,
  Menu,
  MenuItem,
  SubMenu,
} from "react-pro-sidebar";
import { SIDEBAR_MENU } from "../../models/menu-items-model";
import "./LeftSidebar.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LeftSidebar = ({ rtl, toggled, handleToggleSidebar, collapsed }) => {
  const { t } = useTranslation();
  const updateDimension = () => {
    if (toggled) {
      setIsCollapsed(false);
    } else {
      if (window.innerWidth < 768) {
        setIsCollapsed(true);
      } else if (window.innerWidth < 992) {
        setIsCollapsed(true);
      } else if (window.innerWidth < 1200) {
        setIsCollapsed(false);
      } else {
        setIsCollapsed(false);
      }
    }
  };
  useEffect(() => {
    updateDimension();
    window.addEventListener("resize", updateDimension);
    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  });
  const [isCollapsed, setIsCollapsed] = useState(undefined);

  return (
    <>
      <ProSidebar
        toggled={toggled}
        rtl={rtl}
        onToggle={handleToggleSidebar}
        collapsedWidth={"70px"}
        collapsed={isCollapsed}
        breakPoint={"md"}
        key={"sidebar"}
      >
        <SidebarHeader key={"sidebar-header"}>
          <div className="sidebar-btn-wrapper">
            <Link to={"/"} className=" text-center logo-light">
              <span
                className="logo-lg"
                style={{ display: isCollapsed ? "none" : "" }}
              >
                <img src={logo} alt="logo" height="100" width="auto" />
              </span>
              <span
                className="logo-sm"
                style={{ display: !isCollapsed ? "none" : "" }}
              >
                <img src={logCollapsed} alt="logo" height="70" />
              </span>
            </Link>
          </div>
        </SidebarHeader>
        <SidebarContent key={"sidebar-content"}>
          {SIDEBAR_MENU.map((item, index) => {
            if (item.submenu.length > 0) {
              return (
                <Menu key={"sidebar-menu" + item.title}>
                  <SubMenu
                    popperarrow={true}
                    firstchild={true}
                    title={t(item.title)}
                    key={index + t(item.title)}
                    defaultOpen={window.location.pathname.includes(item.path)}
                   
                  >
                    {item.submenu.map((subItem, subIndex) => {
                      return (
                        <MenuItem
                          key={subIndex + t(subItem.title)}
                          active={window.location.pathname === subItem.path}
                        >
                          <Link to={subItem.path} key={"link" + subIndex}>
                            <span >{t(subItem.title)}</span>
                          </Link>
                        </MenuItem>
                      );
                    })}
                  </SubMenu>
                </Menu>
              );
            } else {
              return (
                <Menu key={"sidebar-menu" + item.title}>
                  <MenuItem
                    key={index + t(item.title)}
                    active={window.location.pathname === item.path}
                   
                  >
                    <Link to={item.path} key={"link" + index}>
                      <span>{t(item.title)}</span>
                    </Link>
                  </MenuItem>
                </Menu>
              );
            }
          })}
        </SidebarContent>
      </ProSidebar>
    </>
  );
};
export default LeftSidebar;
